import axios from 'axios';
import { useEffect,useState } from 'react';
import { useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';




function AffichageAncienSelectionJoueur(props) {
    const [isLoading,setIsLoading] = useState(false)
    const [error,setError] = useState();
    const { idMatch } = useParams();
    const [joueur,setJoueur] = useState()
    const [pasDispo,setPasDispo] = useState()
    const Navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;



    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
          try {
            const response = await axios.get(
              `${apiUrl}/selection/affichage/joueur/${props.userData.user.donnée.results[0].id_equipe}/${idMatch}/${props.userData.user.donnée.results[0].id}`,
              {
                withCredentials: true 
              }
            );
            
            setError(null);
            setIsLoading(false);
            setJoueur(response.data);
    
          } catch (error) {
            if (error.response) {
              if (error.response.status === 404) {
                setPasDispo(error.response.data);
            } else {
                setError(error.response.data.message);
            }
          } else {
              setError(true);
          }
          setIsLoading(false);
      }
  };
    
        fetchData(); 
      }, [props, idMatch, apiUrl]);



  return (
    <>
      {error && (
        <div id="alert-message" className="alert5" >
            <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
        </div>
       )}
      {pasDispo && (
        <Modal show={pasDispo} onHide={() => Navigate('/joueurs/tableau-de-bord/selection')}>
          <Modal.Header closeButton>
            <Modal.Title>La sélection n'existe pas</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>Malheureusement, la sélection pour le match {pasDispo.match[0].equipe_dom} - {pasDispo.match[0].equipe_ext} n'existe pas.</>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => Navigate('/joueurs/tableau-de-bord/selection')} >
              Quitter
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    {joueur &&
      <>
        <Card className="bg-dark text-white" style={{borderRadius: "var(--bs-card-border-radius)"}}>
            <Card.Img src="/img/matchArbitre.jpg" alt="Card image" />
            <Card.ImgOverlay>
            <div className="text-center mb-3">
              <Card.Title><strong>Sélection : {joueur.match[0].equipe_dom} - {joueur.match[0].equipe_dom}</strong></Card.Title>
            </div>
          </Card.ImgOverlay>
        </Card><br/>
        <Card>
          <Card.Header>Sélection du coach</Card.Header>
          <Card.Body>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Card.Text>Votre statut pour le match {joueur.match[0].equipe_dom} - {joueur.match[0].equipe_ext} </Card.Text>
            <Form.Select aria-label="Default select example"  defaultValue={joueur.selection[0].status} disabled>
                      <option value="Pas sélectionné">Pas sélectionné</option>
                      <option value="Sélectionné" >Sélectionné</option>
                      <option value="Blessé">Blessé</option>
                </Form.Select>
                <Form.Label>Commentaire personnel</Form.Label>
                <Form.Control as="textarea" rows={3} disabled value={joueur.selection[0].commentaire} />
                <Form.Label>Commentaire pour toute l'équipe</Form.Label>
                <Form.Control as="textarea" rows={3} disabled value={joueur.match_commentaire[0].commentaire} />
          </Form.Group>
          </Card.Body>
        </Card>
    </>
    }
    <br/>

    
    {isLoading && (
        <div className="centered-content">
          <img src="/img/logo.png" alt="Logo" className="centered-logo" />
          <br/>
          <span className="loader"></span>
        </div>
    )}
  </>
  );
}

export default AffichageAncienSelectionJoueur;